<h2>Perfis de acesso</h2>
<div class="card">
  <div class="btn-new-profile">
    <button class="btn danger" (click)="openDialogNewProfile()">
      Criar novo perfil
    </button>
  </div>

  <div class="header-profiles">
    <p>
      Perfis
      <img
        src="assets/img/arrows.png"
        alt="Sort"
        (click)="sortProfilesByName()"
      />
    </p>
    <p>Ações</p>
  </div>

  @for (profile of profiles; track profile.id; let profileIndex = $index) {
  <div class="details">
    <div class="collapse">
      <div class="profile-name">
        <img
          [ngClass]="{ rotate: profileId === profile.id }"
          src="assets/img/Arrow,.png"
          alt="arrow"
          width="24"
          height="24"
          (click)="toggleCollapse(profile.id)"
        />
        <p>{{ profile.name }}</p>
      </div>

      <div class="actions">
        <div
          class="toggle"
          (click)="changeStatus(profileIndex, profile.id)"
        ></div>
        <mat-slide-toggle
          [checked]="!profile.removed"
          [disabled]="profile.id === '0ce77a2a-70a4-477d-9720-aada64089436'"
        ></mat-slide-toggle>

        @if(profile.id !== '0ce77a2a-70a4-477d-9720-aada64089436'){
        <img
          src="assets/img/edit.png"
          alt="Edit"
          (click)="openDialogEditProfile(profile)"
        />
        }
      </div>
    </div>

    <ng-container *ngIf="profileId === profile.id">
      @for (item of permissions; track $index) {
      <div class="permissions">
        <p class="title">
          <mat-checkbox
            (change)="addAllSectionPermissions(item)"
            [checked]="checkAllSelected(item.section)"
            [disabled]="profile.id === '0ce77a2a-70a4-477d-9720-aada64089436'"
          >
          </mat-checkbox>
          {{ item.section }}
        </p>
        @for (per of item.permissions; track $index) {

        <div class="content-box">
          <div class="checkbox" (click)="changePermission(per)"></div>
          <mat-checkbox
            [checked]="permissionsName.includes(per.name)"
            [disabled]="profile.id === '0ce77a2a-70a4-477d-9720-aada64089436'"
          >
            {{ per.description }}
          </mat-checkbox>
        </div>

        }
      </div>
      }
    </ng-container>
  </div>
  }
</div>
@if(profileId && profileId !== '0ce77a2a-70a4-477d-9720-aada64089436'){
<button
  class="btn danger save-preferences"
  (click)="save()"
  [disabled]="checkChangeProfile()"
>
  Salvar alterações
</button>
}
